export const CURRENT_APP_BUILD_ID = __APP_BUILD_ID__;
const VERSION_CHECK_TIMEOUT_MS = 5_000;

interface AppVersionPayload {
  buildId?: unknown;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export async function fetchLatestAppBuildId(
  fetchImpl: typeof fetch = window.fetch,
): Promise<string | null> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), VERSION_CHECK_TIMEOUT_MS);

  try {
    const response = await fetchImpl(`/version.json?ts=${Date.now()}`, {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return null;

    const payload = (await response.json()) as unknown;
    if (!isRecord(payload)) return null;

    const { buildId } = payload as AppVersionPayload;
    return typeof buildId === 'string' && buildId.trim().length > 0 ? buildId : null;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
